(function (scope) {

scope.FormsDonorBox = function (options) {
	var me = this;
	me._donorBoxEmbed = $(".donor-box-embed");
	me._options = options;
	if (me._donorBoxEmbed.length) {
		$(window).on ("scroll", function () {
			// console.log (me._donorBoxEmbed[0].getBoundingClientRect ());
			var rect = me._donorBoxEmbed[0].getBoundingClientRect ();
			if (Math.floor(rect.y) == 0) {
				//donor box has auto-scrolled so that donor box is at top of the page.
				//hide the header
				if (typeof (me._options.onDonorBoxScroll) == "function") {
					me._options.onDonorBoxScroll ();
				}
			}
		});
	}
};

}) (window);
